import { ItemList } from '../orm'
import { head } from 'lodash'
import cookie from 'react-cookies'

class PurchasedTrolleyList extends ItemList {
    getEntityKey() {
        return "customer/purchased_trolley"
    }
}

export const purchasedTrolleyList = new PurchasedTrolleyList("purchased_trolley_default")
